import { Box } from '@mui/material';
import './StepDescriptionBox.css';

interface StepDescriptionBoxProps {
  step: number,
  children: React.ReactNode
}

const StepDescriptionBox:React.FC<StepDescriptionBoxProps> = ({ step, children }) => {
  const getBorderColorStyle = () => {
    return {
      borderColor: `#217F70${(Number.parseInt((255 / 7).toString()) * step + Number.parseInt((255 / 7).toString()) * 1).toString(16).toUpperCase().padStart(2, '0')} !important`
    };
  };

  return (
    <Box className="StepDescriptionBox-Container" sx={{ ...getBorderColorStyle() }}>
      <Box
        className="StepDescriptionBox-StepNumber">
        {step}
      </Box>
      <Box className="StepDescriptionBox-StepDescription">
        {children}
      </Box>
    </Box>

  );
};

export default StepDescriptionBox;
